import type { UserListType } from '../api';

export const getUserName = (user?: UserListType) => {
  return user?.username || user?.firstName || user?.id || 'Unknown user';
};
